import { FiArrowRight, FiCheckCircle, FiAlertCircle, FiLoader } from 'react-icons/fi';
import { runLabel, timeLabel } from './commands';
import CurrencySyncResult from './CurrencySyncResult';

export function CommandDetails({ command, visible }) {
    return visible ? <div className="command-code" aria-label={`Technical details for ${command.title}`}>
        <span>SERVER COMMAND{command.code.length > 1 ? 'S' : ''}</span>
        {command.code.map((line) => <code key={line}>{line}</code>)}
    </div> : null;
}

export function RunResult({ result }) {
    if (!result) return null;
    const Icon = result.status === 'running' ? FiLoader : result.status === 'success' ? FiCheckCircle : FiAlertCircle;
    return <div className={`command-result command-result-${result.status}`} role={result.status === 'error' ? 'alert' : 'status'}>
        <Icon aria-hidden="true" /><div><strong>{result.status === 'running' ? 'Running command…' : result.message}</strong>
            <span>{result.status === 'running' ? 'Waiting for the server to finish.' : `${runLabel(result.status)} at ${timeLabel(result.finishedAt)}`}</span></div>
    </div>;
}

export default function CommandCard({ command, showDetails, result, running, onRun }) {
    const Icon = command.icon;
    const busy = running === command.id;
    return <article className="command-card" aria-labelledby={`command-${command.id}-title`} aria-busy={busy}>
        <div className={`command-card-icon command-tone-${command.tone}`}><Icon aria-hidden="true" /></div>
        <h3 id={`command-${command.id}-title`}>{command.title}</h3>
        <p>{command.description}</p>
        <CommandDetails command={command} visible={showDetails} />
        <div className="command-card-bottom"><button type="button" className="portal-button command-run-button" disabled={Boolean(running)} onClick={(event) => onRun(command, undefined, event.currentTarget)}>
            {busy ? <><FiLoader className="command-spin" aria-hidden="true" />Running…</> : <>{result?.status === 'error' ? 'Try again' : command.action}<FiArrowRight aria-hidden="true" /></>}
        </button><RunResult result={result} />{command.id === 'currencies' && <CurrencySyncResult result={result} />}</div>
    </article>;
}
